import { EventAvailable, EventBusy, People } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Grow,
  Skeleton,
  Typography,
  chipClasses,
} from '@mui/material';
import classes from './style';
import { Link } from 'react-router-dom';
// import { encode } from 'js-base64';
import { toReadableDateTimeString } from '../../utils/dateFormatter';
import Image from 'mui-image';
import { generate } from '../../utils/generateToken';

const IraceEvent = ({ event, i }) => {
  // console.log('irace event ke ', i + 1, event);

  return (
    <Grid item xs={12} sm={6} md={4} style={classes.event}>
      <Grow key={i} in timeout={(i + 1) * 250}>
        <Link
          style={classes.link}
          to={`/event/${generate(
            JSON.stringify({ id: event?.eventId, type: event?.eType })
          )}`}
        >
          <Card
            style={{
              margin: '5px',
              borderRadius: '20px',
              marginBottom: '10px',
            }}
            sx={{ width: { xs: '98%', sm: '95%' } }}
            variant="elevation"
            elevation={5}
          >
            <Box
              sx={{
                height: { xs: '180px', lg: '225px', xl: '300px' },
              }}
            >
              <Image
                src={event?.banner}
                alt={event?.name}
                style={classes.banner}
                duration={500}
                showLoading={
                  <Skeleton
                    variant="rectangular"
                    width={'100%'}
                    sx={{ height: { xs: '150px', sm: '180px', md: '20em' } }}
                  />
                }
              />
            </Box>
            <CardContent sx={{ paddingTop: '0', marginBottom: '-10px' }}>
              <Typography
                sx={{ typography: { xs: 'h6', sm: 'h5', lg: 'h4', xl: 'h3' } }}
                gutterBottom
              >
                {event.name}
              </Typography>
              <Typography gutterBottom>
                <Chip
                  icon={<EventAvailable />}
                  label={toReadableDateTimeString(event.startRegistrationDate)}
                  variant="outlined"
                  color="primary"
                  sx={{
                    height: { xl: '42px', md: '38px' },
                    fontSize: { xl: '24px', md: '20px' },
                  }}
                  style={{
                    paddingInline: '6px',
                    letterSpacing: '1px',
                  }}
                />
              </Typography>

              <Typography gutterBottom>
                <Chip
                  icon={<EventBusy />}
                  label={toReadableDateTimeString(event?.endRegistrationDate)}
                  variant="outlined"
                  color="primary"
                  sx={{
                    height: { xl: '42px', md: '38px' },
                    fontSize: { xl: '24px', md: '20px' },
                  }}
                  style={{
                    paddingInline: '6px',
                    letterSpacing: '1px',
                  }}
                />
              </Typography>
              <Box
                display={'flex'}
                flexDirection={'row'}
                flexWrap={'wrap'}
                marginTop={'20px'}
              >
                {event?.sports?.map((sport, idx) => (
                  <Chip
                    key={idx}
                    label={sport.name}
                    style={{
                      marginRight: '10px',
                      paddingInline: '4px',
                      color: '#830000',
                      backgroundColor: '#ffd3d3',
                      marginBottom: '6px',
                    }}
                    sx={{
                      height: { xl: '42px', md: '38px' },
                      fontSize: { xl: '24px', md: '20px' },
                    }}
                  />
                ))}
                <Chip
                  label={event.participant}
                  style={{
                    paddingInline: '4px',
                    color: '#830000',
                    backgroundColor: '#ffd3d3',
                  }}
                  icon={<People />}
                  sx={{
                    [`& .${chipClasses.icon}`]: {
                      color: '#830000',
                    },
                    height: { xl: '42px', md: '38px' },
                    fontSize: { xl: '24px', md: '20px' },
                  }}
                />

                <Box
                  flex={1}
                  display={'flex'}
                  justifyContent={'flex-end'}
                  alignItems={'center'}
                >
                  <Chip
                    label={event.eType}
                    style={{
                      paddingInline: '4px',
                      color: '#f0f0f0',
                      backgroundColor: '#6d8196',
                    }}
                    // icon={<People />}
                    sx={{
                      // [`& .${chipClasses.icon}`]: {
                      //   color: '#830000',
                      // },
                      height: { xl: '42px', md: '38px' },
                      fontSize: { xl: '24px', md: '20px' },
                    }}
                  />
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Link>
      </Grow>
    </Grid>
  );
};

export default IraceEvent;
